import { fetchApi } from 'Utils/utils';

let fetchConfig = function() {
  return fetchApi.get('/api/v1/auiConfig/');
};

export { fetchConfig };
